import { createGenericContext, GetBemBlocksWith } from "@ebsco-ui/utils";

export interface InPageContext {
  getBlocksWith: GetBemBlocksWith;
}

export const {
  useGenericContext: useInPageContext,
  GenericContextConsumer: InPageContextConsumer,
  GenericContextProvider: InPageContextProvider,
} = createGenericContext<InPageContext>({
  errorMessage:
    "InPageNotification compound components cannot be rendered outside of the InPageNotification component",
});
